import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';

function SubmitButton({ children, onClick, style, enabled, warning=false, loading=false }) {
  const [internalLoading, setInternalLoading] = useState(false);

  const handleClick = () => {
    setInternalLoading(true);
    onClick();
  }

  const primary = !warning;
  // Use either the external loading prop or internal loading state
  const isLoading = loading || internalLoading;

  if (!enabled) {
    return (
      <Button type='submit' primary={primary} negative={warning} disabled style={style} fluid size="large">
        { children }
      </Button>
    );
  }

  if (isLoading) {
    return (
      <Button type='submit' primary={primary} negative={warning} disabled style={style} fluid size="large">
        <Icon name="spinner" loading />
      </Button>
    );
  }

  // default
  return (
    <Button type='submit' primary={primary} negative={warning} onClick={handleClick} style={style} fluid size="large">
      { children }
    </Button>
  )
}

export default SubmitButton;